import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { copyToClipboard } from "../helpers/utils";

const CopyButton = ({text = '', children}) => {
  const [isCopy, setIsCopy] = React.useState(false)

  React.useEffect(() => {
    if (!isCopy) return void 0;

    setTimeout(() => {
      setIsCopy(false)
    }, 2000)
  }, [isCopy])

  const onClickCopy = () => {
    copyToClipboard(text)
    setIsCopy(true)
  }

  return (
    <CopyButtonStyled onClick={onClickCopy}>
      {children || <></>}
      <i className={`${!isCopy ? 'bx bx-copy' : 'mdi mdi-check-bold'}`}/>
    </CopyButtonStyled>
  );
};

CopyButton.propTypes = {
  text: PropTypes.string.isRequired,
  children: PropTypes.any,
};

const CopyButtonStyled = styled.div`
  display: inline-flex;
  background-color: transparent;
  border: none;
  outline: none;
  align-items: center;
  cursor: pointer;

  &:hover {
    
    span {
      color: rgb(85,110,230);
    }
    
    i {
      color: rgb(85,110,230);
    }
  }
`;

export default CopyButton;